import type { BlockEditorHandle } from '@w/content-blocks-editor'

export function focusPageTitle(handle: BlockEditorHandle): boolean {
  handle.focusTitle({ selectText: true })
  return true
}

export function schedulePageTitleFocus(handle: { current: BlockEditorHandle | null }): void {
  requestAnimationFrame(() => { handle.current?.focusTitle({ selectText: true }) })
}

/** Stored name of a page nobody has named yet (flashcards-editor-home.decisions.md: "Untitled page"). */
export const untitledPageTitle = 'Untitled page'

/**
 * A click into a title that still reads the untouched fallback keeps the whole title selected,
 * so typing replaces it instead of appending (flashcards-editor-home.spec.md, lead decision 2026-10-16).
 */
export function selectUntouchedTitleOnClick(handle: BlockEditorHandle | null, target: EventTarget): void {
  if (!handle || !(target instanceof Element) || !target.closest('[data-testid="content-blocks-editor-page-title"]')) return
  if (handle.getSnapshot().pageTitle !== untitledPageTitle || !window.getSelection()?.isCollapsed) return
  handle.focusTitle({ selectText: true })
}
